import { useEffect, useState } from '@wordpress/element';
export { __ } from '@wordpress/i18n';

export function useLocale() {
	const [ locale, setLocale ] = useState< string >();

	useEffect( () => {
		if ( ! locale ) {
			const lang = document.documentElement.getAttribute( 'lang' );
			setLocale( lang?.replace( '-', '_' ) )
		}
	}, [] );

	return locale;
}

export type NumberFormat = {
	decimalScale: number,
	decimalSeparator: string,
	thousandSeparator: string
};

export function useNumberFormat(): NumberFormat {
	const locale = useLocale();

	const format = {
		decimalScale: 2,
		decimalSeparator: '.',
		thousandSeparator: ','
	};

	if ( locale == 'de_DE' ) {
		format.decimalSeparator = ',';
		format.thousandSeparator = '.';
	}

	return format;
}
